<template>
  <v-app>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <v-container fluid>
            <v-card-title>
              <v-btn
                @click="create = !create"
                class="btn-add-with-text"
                v-status="'create_customer_history'"
              >
                <v-icon>mdi-plus</v-icon>
                ثبت تاریخچه ی جدید
              </v-btn>
              <v-spacer />
              {{ $t($route.meta.title) }}
              <v-spacer />
              <v-btn
                :loading="loading"
                @click="showMessageModal"
                class="btn-send-sms"
                v-status="'send_one_message_customer'"
              >
                <v-icon>mdi-email-check</v-icon>
                ارسال پیام
              </v-btn>
            </v-card-title>
            <v-divider />

            <div class="row">
              <div class="col-md-12 p-5">
                <data-table
                  orderDir="desc"
                  :data="data"
                  :columns="columnTransactions"
                  :translate="translates"
                  :per-page="perPages"
                  @on-table-props-changed="reloadTable"
                >
                </data-table>
              </div>
            </div>
          </v-container>
        </div>
        <v-dialog
          transition="dialog-bottom-transition"
          v-model="create"
          persistent
          max-width="800"
        >
          <template v-slot:default="create">
            <v-card>
              <v-toolbar color="#b54405" class="font-weight-bold" dark>
                <v-icon>mdi-history</v-icon>
                ثبت تاریخچه جدید
                <v-spacer></v-spacer>
                <v-btn
                  small
                  icon
                  rounded
                  @click="canselHistory"
                  class="ml-1 text-hover-danger text-white"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-row class="mt-5">
                  <v-flex class="p-2" xs12 sm12 md6 xl6 lg6>
                    <v-text-field
                      outlined
                      label="عنوان"
                      v-model="createHistory.title"
                      dense
                      :error-messages="historyErrors.title"
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="p-2" xs12 sm12 md6 xl6 lg6>
                    <v-text-field
                      outlined
                      label="مرحله"
                      v-model="createHistory.status"
                      dense
                      :error-messages="historyErrors.status"
                    ></v-text-field>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex class="p-2" xs12 sm12 md12 xl12 lg12>
                    <date-picker
                      label="تاریخ آخرین تماس"
                      format="YYYY-MM-DD HH:mm"
                      :min="data.now"
                      type="time"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      v-model="createHistory.current_time"
                    ></date-picker>
                    <div v-if="historyErrors.length != 0">
                      <p
                        class="mt-2 text-danger"
                        v-if="historyErrors.current_time"
                        v-for="(des, ind) in historyErrors.current_time"
                        :key="ind"
                      >
                        {{ des }}
                      </p>
                    </div>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-container fluid>
                    <v-alert>مذاکرات انجام شده :</v-alert>
                    <ckeditor
                      :editor="editor.editor"
                      v-model="createHistory.description"
                      :config="editor.editorConfig"
                    >
                    </ckeditor>
                    <div v-if="historyErrors.length != 0">
                      <p
                        class="mt-2 text-danger"
                        v-if="historyErrors.description"
                        v-for="(des, ind) in historyErrors.description"
                        :key="ind"
                      >
                        {{ des }}
                      </p>
                    </div>
                  </v-container>
                </v-row>
                <v-row>
                  <v-flex class="p-2" xs12 sm12 md12 xl12 lg12>
                    <date-picker
                      label=" تاریخ تماس بعدی"
                      format="YYYY-MM-DD HH:mm"
                      type="datetime"
                      :min="data.tomorrow"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      v-model="next_time"
                    ></date-picker>
                    <div v-if="historyErrors.length != 0">
                      <p
                        class="mt-2 text-danger"
                        v-if="historyErrors.next_time"
                        v-for="(des, ind) in historyErrors.next_time"
                        :key="ind"
                      >
                        {{ des }}
                      </p>
                    </div>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-container fluid>
                    <v-alert>موارد پیگیری در تماس بعدی :</v-alert>
                    <ckeditor
                      :editor="editor.editor"
                      v-model="createHistory.pursue_text"
                      :config="editor.editorConfig"
                    >
                    </ckeditor>
                    <div v-if="historyErrors.length != 0">
                      <p
                        class="mt-2 text-danger"
                        v-if="historyErrors.pursue_text"
                        v-for="(des, ind) in historyErrors.pursue_text"
                        :key="ind"
                      >
                        {{ des }}
                      </p>
                    </div>
                  </v-container>
                </v-row>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn class="btn-cancel" @click="canselHistory">
                  <v-icon>mdi-close-circle</v-icon>
                  بستن
                </v-btn>
                <v-btn
                  class="submit-btn"
                  @click="store"
                  :loading="storeloading"
                  :disabled="storeloading"
                >
                  <span class="fa fa-bookmark icon-md ml-1"></span>
                  ذخیره
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
        <v-dialog v-model="messageModal" persistent max-width="400px">
          <v-card>
            <v-card-title>
              <span class="text-h5">ارسال پیام</span>
              <v-spacer></v-spacer>
              <v-btn
                small
                icon
                rounded
                @click="canselMessage"
                class="ml-1 text-danger"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <v-autocomplete
                      :items="messageCategories.data"
                      item-text="title"
                      v-model="category_id"
                      :loading="loadingCategory"
                      @change="getMessageQuery"
                      item-value="id"
                      clearable
                      outlined
                      dense
                      label="انتخاب دسته بندی"
                    >
                      <template slot="item" slot-scope="{ item, tile }">
                        <div>{{ item.title }}</div>
                      </template>
                      <template slot="append-item">
                        <v-container>
                          <div class="text-center">
                            <v-pagination
                              v-model="page"
                              :length="messageCategories.last_page"
                              :total-visible="2"
                              circle
                            ></v-pagination>
                          </div>
                        </v-container>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md12
                    lg12
                    xl12
                    class="p-2"
                    v-if="messages.data"
                  >
                    <v-autocomplete
                      :items="messages.data"
                      dense
                      filled
                      clearable
                      item-text="title"
                      item-value="id"
                      :error-messages="messageError.id"
                      v-model="message"
                      return-object
                      label="عنوان پیام"
                    >
                    </v-autocomplete>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex class="p-2" xs12 sm12 md12 xl12 lg12>
                    <date-picker
                      label=" تاریخ تماس بعدی"
                      format="YYYY-MM-DD HH:mm"
                      :min="data.tomorrow"
                      type="datetime"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      v-model="next_time"
                    ></date-picker>
                  </v-flex>
                  <div v-if="messageError.length != 0">
                    <p
                      class="mt-2 text-danger font-weight-bold"
                      v-if="next_time"
                      v-for="(des, ind) in messageError.next_time"
                      :key="ind"
                    >
                      {{ des }}
                    </p>
                  </div>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="btn-cancel" @click="canselMessage"> انصراف </v-btn>
              <v-btn class="submit-btn" @click="sendSms"> ارسال </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showDescription" max-width="400px">
          <v-card>
            <v-card-title>
              <!--              <span class="text-h5">ارسال پیام</span>-->
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-flex class="p-2" xs12 sm12 md12 xl12 lg12>
                    <v-text-field disabled label="توضیحات"></v-text-field>
                    <v-textarea
                      outlined
                      label="پیگیری تماس بعدی"
                      readonly
                      v-html="description"
                    ></v-textarea>
                    <div v-if="pursueText !== null">
                      <v-text-field
                        disabled
                        label="پیگیری تماس بعدی"
                      ></v-text-field>
                      <v-textarea
                        outlined
                        label="پیگیری تماس بعدی"
                        readonly
                        v-html="pursueText"
                      ></v-textarea>
                    </div>
                  </v-flex>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </v-app>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import HistoryBtn from "@/view/pages/admin/users/actions/HistoryBtn";

export default {
  name: "CustomerHistory",
  props: ["phone"],
  data() {
    return {
      storeloading: false,
      page: 1,
      messageCategories: [],
      categoryUrl: "message/categories",
      query: {
        page: 1,
        search: "",
        length: 5,
      },
      loadingCategory: false,
      category_id: null,
      search: null,
      showDescription: false,
      description: null,
      historyErrors: [],
      next_time: null,
      messageError: [],
      messageModal: false,
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        },
      },
      create: false,
      url: "customer/history",
      createHistory: {
        status: null,
        pursue_text: null,
        phoneNumber: this.phone,
        title: null,
        description: null,
        current_time: null,
      },
      data: {},
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      loading: false,
      columnTransactions: [
        {
          name: "id",
          label: "شناسه",
          orderable: true,
        },
        {
          name: "title",
          label: "عنوان",
          orderable: true,
          searchable: true,
        },
        {
          name: "status",
          label: "مرحله",
          orderable: true,
          searchable: true,
        },
        {
          name: "current_time",
          label: "تاریخ آخرین تماس",
          orderable: true,
          transform: (val) => {
            return this.$options.filters.onlyDate(val.data.current_time);
          },
        },
        {
          label: "ساعت آخرین تماس",
          orderable: true,
          transform: (val) => {
            return this.$options.filters.onlyTime(val.data.current_time);
          },
        },
        {
          name: "next_time",
          label: "تاریخ تماس بعدی",
          orderable: true,
          transform: (val) => {
            return this.$options.filters.onlyDate(val.data.next_time);
          },
        },
        {
          label: "ساعت تماس بعدی",
          orderable: true,
          transform: (val) => {
            return this.$options.filters.onlyTime(val.data.next_time);
          },
        },
        {
          name: "user_id",
          label: "پشتیان",
          transform: (val) => {
            return val.data.owner.username;
          },
        },
        {
          name: "actions",
          label: "عملیات",
          component: HistoryBtn,
          handler: this.actions,
          event: "action",
        },
      ],
      rules: {},
      messageUrl: "user/messages",
      messages: [],
      message: [],
      pursueText: null,
      message_id: null,
    };
  },
  watch: {
    showDescription(val) {
      if (val === false) this.pursueText = null;
    },
    page(val) {
      this.query.page = val;
      console.log(val);
      this.getMessageCategories(this.categoryUrl, this.query);
    },
    // search(val) {
    //   this.tableProps.search = val;
    //   this.getMessages(this.messageUrl, this.tableProps)
    // },
    next_time(val) {
      let a = new Date("YYYY-MM-DD");

      // )
    },
  },

  methods: {
    getMessageQuery() {
      if (this.category_id !== null) return this.getMessage(this.category_id);
      if (this.search !== null) return (this.messages = []);
    },
    getMessageCategories(url = this.categoryUrl, query = this.query) {
      if (query.search === null) this.$modal.showLoading();
      this.loadingCategory = true;
      this.requestApiGet(url, query)
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.loadingCategory = false;
          this.messageCategories = data;
        })
        .catch(({ response }) => {
          this.loadingCategory = false;
          this.$modal.hideLoading();
        });
    },

    onIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.getMessages();
      }
    },
    reloadTable(tableProps) {
      this.getHistory(this.url, tableProps);
    },

    sendSms() {
      this.$modal.showLoading();
      this.requestApiPost("customer/send-sms", {
        phone_number: this.phone,
        title: this.message.title,
        message_id: this.message.id,
        description: this.message.description,
        next_time: this.next_time,
        notif_id: this.$route.query.notifId,
      })
        .then(({ data }) => {
          this.$toast.success("پیام با موفقیت ارسال شد.");
          this.canselMessage();
          this.getHistory();
          this.$modal.hideLoading();
        })
        .catch(({ response }) => {
          this.messageError = response.data.errors;
          this.$modal.hideLoading();
        });
    },

    getHistory(url = this.url, query = this.tableProps) {
      this.requestApiGet(`${url}/${this.phone}`, query)
        .then(({ data }) => {
          this.data = data;
          this.next_time = data.tomorrow;
        })
        .catch(({ response }) => {});
    },

    getMessage(query) {
      this.requestApiGet(`user/messages/${query}`)
        .then((data) => {
          this.$modal.hideLoading();
          this.messages = data;
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
        });
    },
    async showMessageModal() {
      await this.getMessageCategories();
      this.messageModal = !this.messageModal;
    },

    store() {
      if (this.storeloading) return;
      this.storeloading = true;
      this.$modal.showLoading();
      this.requestApiPost(`customer/history/${this.phone}`, {
        ...this.createHistory,
        next_time: this.next_time,
        notif_id: this.$route.query.notifId,
      })
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.canselHistory();
          this.$toast.success("تاریخچه با موفقیت ثبت شد.");
          this.getHistory();
          this.storeloading = false;
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
          this.historyErrors = response.data.errors;
          this.storeloading = false;
        });
    },

    canselHistory() {
      this.create = false;
      this.data.title = null;
      this.data.description = null;
      this.data.status = null;
      this.data.current_time = null;
      this.next_time = this.data.tomorrow;
      this.historyErrors = [];
    },
    canselMessage() {
      this.messageModal = false;
      this.next_time = this.data.tomorrow;
      this.message = [];
    },
    actions(data, type) {
      this[type](data);
    },
    history(data) {
      this.showDescription = true;
      this.description = data.description;
      this.pursueText = data.pursue_text;
    },
    pattern(data) {
      this.showDescription = true;
      this.description = data.description;
    },
    messageFun(data) {
      this.showDescription = true;
      this.description = data.description;
    },
  },
  created() {
    this.getHistory(this.url);
  },
};
</script>

<style scoped></style>
